import { validateEmail } from '../../../../../utils/emailValidator';

const TRANSLATION_KEY = 'PAGES.MY_GROUPS.MODALS.ADD_MEMBER';

const VO_NAME_INVALID_CHARACTERS = /[0-9@]/;
const VO_USERNAME_INVALID_CHARACTERS = /[@\sA-Z]/;
const USERNAME_MAX_LENGTH = 250;
const PASSWORD_MIN_LENGTH = 4;
const PASSWORD_MAX_LENGTH = 50;

export function validateMemberFirstName(value: string | undefined) {
  if (!value) return 'FORM.VALIDATION.REQUIRED';
  if (VO_NAME_INVALID_CHARACTERS.test(value)) return `${TRANSLATION_KEY}.FORM.FIRST_NAME.ERROR.FORMAT`;
  return undefined;
}

export function validateMemberLastName(value: string | undefined) {
  if (!value) return 'FORM.VALIDATION.REQUIRED';
  if (VO_NAME_INVALID_CHARACTERS.test(value)) return `${TRANSLATION_KEY}.FORM.LAST_NAME.ERROR.FORMAT`;
  return undefined;
}

export function validateMemberUsername(value: string | undefined, existingUsernames: string[]) {
  if (!value) return 'FORM.VALIDATION.REQUIRED';
  if (value.length > USERNAME_MAX_LENGTH) return `${TRANSLATION_KEY}.FORM.USERNAME.ERROR.MAX_LENGTH`;
  if (VO_USERNAME_INVALID_CHARACTERS.test(value)) return `${TRANSLATION_KEY}.FORM.USERNAME.ERROR.FORMAT`;
  if (existingUsernames.includes(value)) return `${TRANSLATION_KEY}.FORM.USERNAME.ERROR.DUPLICATE`;
  return undefined;
}

export function validateMemberEmail(value: string | undefined) {
  if (value && !validateEmail(value)) return `${TRANSLATION_KEY}.FORM.EMAIL.ERROR.FORMAT`;
  return undefined;
}

export function validateMemberPassword(value: string | undefined) {
  if (!value) return 'FORM.VALIDATION.REQUIRED';
  if (value.length < PASSWORD_MIN_LENGTH) return `${TRANSLATION_KEY}.FORM.PASSWORD.ERROR.MIN_LENGTH`;
  if (value.length > PASSWORD_MAX_LENGTH) return `${TRANSLATION_KEY}.FORM.PASSWORD.ERROR.MAX_LENGTH`;
  if (value.trim() !== value) return `${TRANSLATION_KEY}.FORM.PASSWORD.ERROR.SPACE`;
  return undefined;
}
